import { func } from 'prop-types';
import { useState, useEffect } from 'react';
import { object, string } from 'yup';
import { Form, Field } from 'react-final-form';
import Input from '../Forms/input';
import Message from '../Forms/message';
import Select from '../Forms/select';
import { InputWrapper, FormSection, SectionLabel, Content, ButtonsWrapper } from '../Forms/common';
import { validateFormValues } from '../Forms/formValidation';
import Button from '../StoraEnsoComponents/Button';
import { getSrids } from '../../services/userService';

const LOCATION_TYPE_VALUES = [
  {
    value: 'mill',
    label: 'Mill',
  },
  {
    value: 'forestMulti',
    label: 'Multispectral Forest',
  },
  {
    value: 'forestRGB',
    label: 'RGB Forest',
  }
];

const validationSchema = object({
  name: string()
    .nullable(true)
    .trim()
    .required('Name is required'),
  description: string()
    .nullable(true)
    .trim()
    .required('Description is required'),
  type: object().shape({})
    .nullable(true)
    .required('Type is required'),
  country: string()
    .nullable(true)
    .trim()
    .required('Country is required'),
  srid: object().shape({})
    .nullable(true)
    .required('Srid is required')
});

// TODO
// - handle loading/error
function AddLocationForm({
  handleFormSubmit,
}) {
  const [sridValues, setSridValues] = useState([]);

  useEffect(() => {
    getSrids()
      .then(data => {
        setSridValues(data.map(s => ({ label: `${s.epsg} - ${s.country} `, value: s.epsg })));
    });
  }, [])

  return (
    <Form
      onSubmit={handleFormSubmit}
      validate={validateFormValues({
        schema: validationSchema
      })}
      initialValues={{
        name: '',
        description: '',
        type: null,
        country: '',
        srid: null,
      }}
      render={({ handleSubmit, form }) => (
        <FormSection>
          <SectionLabel>Add new location</SectionLabel>
          <Content>
            <Field name="name">
              {({ input, meta }) => (
                <InputWrapper>
                  <label>Name</label>
                  <Input type="text" {...input} {...meta} />
                  {
                    meta.touched && meta.error && (
                      <Message isError>{meta.error}</Message>
                    )
                  }
                </InputWrapper>
              )}
            </Field>
            <Field name="description">
              {({ input, meta }) => (
                <InputWrapper>
                  <label>Description</label>
                  <Input type="text" {...input} {...meta} />
                  {
                    meta.touched && meta.error && (
                      <Message isError>{meta.error}</Message>
                    )
                  }
                </InputWrapper>
              )}
            </Field>
            <Field name="type">
              {({ input, meta }) => (
                <InputWrapper>
                  <label>Type</label>

                  <Select
                    id="type"
                    options={LOCATION_TYPE_VALUES}
                    placeholder="Select location type"
                    {...input}
                    {...meta}
                    onChange={value => {
                      input.onChange(value);
                    }}
                  />
                  {
                    meta.touched && meta.error && (
                      <Message isError>{meta.error}</Message>
                    )
                  }
                </InputWrapper>
              )}
            </Field>
            <Field name="country">
              {({ input, meta }) => (
                <InputWrapper>
                  <label>Country</label>
                  <Input type="text" {...input} {...meta} />
                  {
                    meta.touched && meta.error && (
                      <Message isError>{meta.error}</Message>
                    )
                  }
                </InputWrapper>
              )}
            </Field>

            <Field name="srid">
              {({ input, meta }) => (
                <InputWrapper>
                  <label>Srid</label>

                  <Select
                    id="srid"
                    options={sridValues}
                    placeholder="Select srid"
                    {...input}
                    {...meta}
                    onChange={value => {
                      input.onChange(value);
                    }}
                  />
                  {
                    meta.touched && meta.error && (
                      <Message isError>{meta.error}</Message>
                    )
                  }
                </InputWrapper>
              )}
            </Field>
            <ButtonsWrapper>
            <Button type="reset" onClick={() => form.reset()}>
                Reset
              </Button>
              <Button type="submit" onClick={handleSubmit}>
                Add location
              </Button>
            </ButtonsWrapper>
          </Content>
        </FormSection>
      )}
    />
  );
}

AddLocationForm.propTypes = {
  handleFormSubmit: func.isRequired,
}

export default AddLocationForm;